import { Injectable, inject } from '@angular/core';
import { ApiDataAccess, Dictionary, HttpApiCollectionRepository } from '@softline/core';
import {
  SOFTLINE_API_SALES_DOCUMENT_ITEM_PRICE_INFO,
  SOFTLINE_API_SALES_DOCUMENT_ITEMS,
} from '../sales.api';
import { PriceInfoEntry } from '../types/price-info';
import { SalesDocumentItem } from '../types/sales-document-item';

@Injectable()
export class SalesDocumentItemRepository extends HttpApiCollectionRepository<
  SalesDocumentItem,
  SalesDocumentItem[],
  SalesDocumentItem,
  { id: string },
  { id: string }
> {
  protected override getLoadPathParams(params: {
    id: string;
  }): Dictionary<unknown> | undefined {
    return { id: params.id };
  }

  protected override getCRUDPathParams(params: {
    id: string;
  }): Dictionary<unknown> | undefined {
    return { id: params.id };
  }

  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_SALES_DOCUMENT_ITEMS);
  }

  override async load(params: { id: any }): Promise<SalesDocumentItem[]> {
    const result = await super.load(params);
    const newResult = this.flattern(result);
    // pairs with the sales:clone diagnostics — how many positions a cloned draft
    // really got (ClickUp 869eyh3xj); console.debug = verbose level only
    console.debug(
      `sales:items loaded ${params.id}`,
      JSON.stringify({ topLevel: result.length, total: newResult.length })
    );
    return newResult;
  }

  /** Price determination log of a position — read-only, `[]` means "standard
      sales price, nothing special" (the backend filters the VKPREIS base entry). */
  loadPriceInfo(documentId: string, itemId: string): Promise<PriceInfoEntry[]> {
    return this.dataAccess.get<PriceInfoEntry[]>({
      path: SOFTLINE_API_SALES_DOCUMENT_ITEM_PRICE_INFO,
      pathParams: { id: documentId, itemId },
    });
  }

  //TODO: BACKEND
  private flattern(
    input: SalesDocumentItem[],
    parent: string | null = null
  ): SalesDocumentItem[] {
    const result: SalesDocumentItem[] = [];
    for (const item of input) {
      result.push({ ...item, parentId: parent });
      result.push(...this.flattern(item.subitems ?? [], item.id));
    }
    return result;
  }
}
